import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useIdentity } from '@zenbusiness/application-commons-identity';

import { GET_LOGO_USERS_QUERY } from '../queries';

const useGetLogoUsersQuery = () => {
  const { identified } = useIdentity();
  const { loading, error, data } = useQuery(GET_LOGO_USERS_QUERY, {
    noThrow: true,
    skip: !identified
  });

  let getLogoUsersCount;

  if (data) {
    getLogoUsersCount = data?.getLogoUsersCount;
  }

  if (error) {
    return {
      isLoading: false,
      logoUsersCount: 0
    };
  }

  return {
    isLoading: loading,
    logoUsersCount: getLogoUsersCount?.logoUsersCount
  };
};

export default useGetLogoUsersQuery;
